// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.info .title {
  font-family: Ubuntu;
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  line-height: 36px;
  text-align: center;
  color: #2a2d8b;
}
.info .text {
  font-family: Ubuntu;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 163.42%;
  text-align: center;
  color: #858585;
}`, "",{"version":3,"sources":["webpack://./src/app/core/shared/components/modais/confirm-trasnfer-pre-cadastro/confirm-trasnfer-pre-cadastro.component.scss"],"names":[],"mappings":"AACE;EACE,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;AAAJ;AAEE;EACE,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,oBAAA;EACA,kBAAA;EACA,cAAA;AAAJ","sourcesContent":[".info {\n  .title {\n    font-family: Ubuntu;\n    font-style: normal;\n    font-weight: bold;\n    font-size: 24px;\n    line-height: 36px;\n    text-align: center;\n    color: #2a2d8b;\n  }\n  .text {\n    font-family: Ubuntu;\n    font-style: normal;\n    font-weight: normal;\n    font-size: 16px;\n    line-height: 163.42%;\n    text-align: center;\n    color: #858585;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
